import { Link } from "react-router-dom";
import { SocialLinks } from "./SocialLinks";

const FOOTER_LINKS = [
    { label: "Home", to: "/" },
    { label: "Services", to: "/services" },
    { label: "Process", to: "/process" },
    { label: "Contact Us", to: "/contact" },
];

const FooterBrand = () => (
    <div className="md:col-span-5">
        <div className="flex items-center">
            <img
                src="/FRANKEL-lockup.png"
                alt="FRANKEL"
                className="h-10 w-auto object-contain"
            />
        </div>
        <p className="font-body text-sm text-black/60 mt-5 max-w-sm leading-relaxed">
            Global AI optimisation and AI agent development for ambitious SMEs.
            World-class intelligence, made accessible.
        </p>
    </div>
);

const FooterNav = () => (
    <div className="md:col-span-3">
        <span className="font-mono text-xs text-black/50 tracking-wider">
            NAVIGATE
        </span>
        <ul className="mt-4 space-y-3">
            {FOOTER_LINKS.map((l) => (
                <li key={l.to}>
                    <Link
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                        to={l.to}
                        onClick={
                            l.to === "/"
                                ? () =>
                                      window.scrollTo({
                                          top: 0,
                                          behavior: "smooth",
                                      })
                                : undefined
                        }
                        className="font-body text-sm text-black/70 hover:text-black transition-colors"
                    >
                        {l.label}
                    </Link>
                </li>
            ))}
        </ul>
    </div>
);

const FooterContact = () => (
    <div className="md:col-span-4">
        <span className="font-mono text-xs text-black/50 tracking-wider">
            CONTACT
        </span>
        <ul className="mt-4 space-y-3">
            <li>
                <a
                    data-testid="footer-email"
                    href="mailto:info@frankel-ai.com"
                    className="font-body text-sm text-black/70 hover:text-black transition-colors break-all"
                >
                    info@frankel-ai.com
                </a>
            </li>
            <li className="font-body text-sm text-black/70">
                Global · Remote-first
            </li>
        </ul>
        <SocialLinks />
    </div>
);

const FooterBottom = () => (
    <div className="mt-14 pt-7 border-t border-black/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="font-mono text-xs text-black/50 tracking-[-0.01em]">
            © {new Date().getFullYear()} FRANKEL. All rights reserved.
        </span>
        <span className="font-mono text-xs text-black/50 tracking-[-0.01em]">
            Global AI Optimisation · SME Automation
        </span>
    </div>
);

export const Footer = () => (
    <footer
        data-testid="footer"
        className="bg-white text-black border-t border-black/10"
    >
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
            <div className="grid md:grid-cols-12 gap-10">
                <FooterBrand />
                <FooterNav />
                <FooterContact />
            </div>
            <FooterBottom />
        </div>
    </footer>
);
